import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { SbSharedCreatorSpotlightProductTile } from '../SbSharedCreatorSpotlightProductTile/SbSharedCreatorSpotlightProductTile';

import styles from './SbRespCreatorSpotlightModule.scss';

function SbRespCreatorSpotlightModuleComponent({ collectionsModules, isClient }) {
    const { title, photo, description, link, linkText, itemsConnection } = collectionsModules;
    const edges = get(itemsConnection, 'edges') || [];

    return (
        <Fragment>
            {title && <BarHeader size="xLarge" title={title} />}

            <div className={`${styles.container} rowFlex`}>
                <div className="colMd6 colXs6">
                    <div className={styles.imgDescContainer}>
                        <div className={`${styles.imgContainer} colMd4 colXs4`}>
                            {photo && (
                                <div className={styles.imgWrapper}>
                                    <img
                                        src={`${photo}?width=300`}
                                        className={styles.img}
                                        alt={title || ''}
                                    />
                                </div>
                            )}
                        </div>

                        <div className={`${styles.descContainer} colMd8 colXs8`}>
                            {description && <div className={styles.desc}>{description}</div>}
                            {link && linkText && (
                                <a href={link} className={styles.link}>
                                    {linkText}
                                </a>
                            )}
                        </div>
                    </div>
                </div>

                {edges.map(edge => (
                    <SbSharedCreatorSpotlightProductTile
                        key={edge.node.serviceId}
                        className={`colMd2 colXs2 ${styles.item}`}
                        edge={edge}
                        isClient={isClient}
                    />
                ))}
            </div>
        </Fragment>
    );
}

SbRespCreatorSpotlightModuleComponent.propTypes = {
    collectionsModules: PropTypes.object.isRequired,
    isClient: PropTypes.bool.isRequired,
};

export const SbRespCreatorSpotlightModule = createFragmentContainer(
    SbRespCreatorSpotlightModuleComponent,
    {
        collectionsModules: graphql`
            fragment SbRespCreatorSpotlightModule_collectionsModules on CollectionsModulesCreatorSpotlight {
                title
                photo
                description
                link
                linkText
                itemsConnection {
                    edges {
                        ...SbSharedCreatorSpotlightProductTile_edge
                        node {
                            serviceId
                        }
                    }
                }
            }
        `,
    }
);
